module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/5/2-0e15ad943c74b19124179de0c2a3fa8c.jpg";